<script>
    //import router from '@/router'
    //import store from '@/store'

    export default {
        name: 'WebsiteMeta',
        render() { return null; },
        beforeMount() {
            this.apply();
        },
        data() {
            return {
                titleSplit: ' - '
            };
        },
        watch: {
            '$route': 'apply',
            '$store.state.websiteSettings': 'apply',
            '$store.state.currentArticle': 'apply'
        },
        methods: {
            apply() {
                let vm = this;
                this.$store.dispatch('getMetas').then(function (response) {
                    const websiteSettings = response.websiteSettings;
                    if (websiteSettings !== null) {
                        vm.addTitle(vm.$store.state.currentPageTitle);
                        vm.addSiteName(websiteSettings.styles.title);
                        vm.addUrl(window.document.location.href.toString());
                        vm.addDescription(vm.$store.state.currentPageDescription);
                        vm.addIcon(websiteSettings.styles.favicon ? websiteSettings.styles.favicon : websiteSettings.styles.imageLogo);

                        //<meta name="description" :content="description">
                        //<meta name="twitter:description" :content="description">
                        //<meta property="og:description" :content="description">

                        //<meta name="twitter:image" :content="picture" v-if="picture">
                        //<meta property="og:image" :content="picture" v-if="picture">

                        //<meta property='og:title' content='Title of the article"/>
                        //<meta property='og:image' content='//media.example.com/ 1234567.jpg"/>
                        //<meta property='og:description' content='Description that will show in the preview"/>
                        //<meta property='og:url' content='//www.example.com/URL of the article" />

                        vm.$root.$once('metaChange');
                    }
                });
            },
            addTitle(Title) {
                let title = Title;
                let addSplit = (this.$store.state.websiteSettings.styles.title !== '');
                if (this.$route.matched[0].props.default.title !== '') {
                    title = this.$route.matched[0].props.default.title + ((addSplit) ? this.titleSplit : '');
                } else if (this.$route.matched[0].props.default.type === 'article' && this.$store.state.currentArticle && this.$store.state.currentArticle.title) {
                    title = this.$store.state.currentArticle.title + ((addSplit) ? this.titleSplit : '');
                } else {
                    title = '';
                }
                title += this.$store.state.websiteSettings.styles.title;
                //this.$store.dispatch('setCurrentPageTitle', title)

                document.title = title;
                let metas = [
                    { name: 'title' },
                    { name: 'twitter:title' },
                    { property: 'og:title' }
                ];
                for (let meta of metas) {
                    this.setMeta(Object.keys(meta)[0], Object.values(meta)[0], title);
                }
            },
            addDescription(Description = '') {
                let div = document.createElement('div');
                let description = ((Description === null) ? '' : Description);
                div.innerHTML = description.trim();
                /*eslint-disable */
                description = div.innerText.replace(/(\.\.\.)/g, '…');
                description = description.replace(/([\.,…:;])/g, '$1 ').trim();
                description = description.replace(/([ ]{2,})/g, ' ').trim();
                /*eslint-enable */
                let metas = [
                    { name: 'description' },
                    { name: 'twitter:description' },
                    { property: 'og:description' }
                ];
                for (let meta of metas) {
                    this.setMeta(Object.keys(meta)[0], Object.values(meta)[0], description);
                }
            },
            addSiteName(SiteName) {
                let metas = [
                    { property: 'og:site_name' }
                ];
                for (let meta of metas) {
                    this.setMeta(Object.keys(meta)[0], Object.values(meta)[0], SiteName);
                }
            },
            addIcon(logo) {
                this.setLink('icon', 'image/png', '32x32', logo);
                this.setLink('icon', 'image/png', '16x16', logo);
            },
            addUrl(Url) {
                let metas = [
                    { property: 'og:url' }
                ];
                for (let meta of metas) {
                    this.setMeta(Object.keys(meta)[0], Object.values(meta)[0], Url);
                }
            },
            setLink(rel, type, sizes, href) {
                let linkElement = document.head.querySelector('link[sizes="' + sizes + '"]');
                if (linkElement === null) {
                    linkElement = document.createElement('link');
                    linkElement.setAttribute('rel', rel);
                    linkElement.setAttribute('type', type);
                    linkElement.setAttribute('href', href);
                    document.head.appendChild(linkElement);
                } else {
                    linkElement.setAttribute('type', type);
                    linkElement.setAttribute('href', href);
                }
                linkElement = null;
            },
            setMeta(property, propertyName, value) {
                let metaElement = document.head.querySelector('meta[' + property + '="' + propertyName + '"]');
                if (metaElement === null) {
                    metaElement = document.createElement('meta');
                    metaElement.setAttribute(property, propertyName);
                    metaElement.setAttribute('content', value);
                    document.head.appendChild(metaElement);
                } else {
                    metaElement.setAttribute('content', value);
                }
                metaElement = null;
            }
        }
    };
</script>
